<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  components: {},
  computed: {
    themeColor() {
      return this.$store.state.app.theme;
    },
  },
  data() {
    return {};
  },
  created() {
    this.$store.dispatch("app/changeTheme").then(res => {
      document.documentElement.setAttribute("theme", this.themeColor);
    });
  },
};
</script>

<style lang="scss">
#app {
  height: 100%;
}
</style>
